import { Phone, Mail, MessageCircle, MapPin, Instagram, Facebook } from "lucide-react";
import { SITE } from "@/site";

export const Footer = () => (
  <footer className="bg-[#0F172A] border-t border-white/10">
    <div className="mx-auto max-w-7xl px-5 md:px-10 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <img src={SITE.logo} alt="MyPT — My Personal Trainer" className="h-16 md:h-24 w-auto" />
          <p className="text-[#94A3B8] mt-6 max-w-sm text-base leading-relaxed">
            Mobile personal training & nutrition guidance. I bring the gym to you — feel strong,
            move well, and feel young at any age.
          </p>
          <div className="flex items-center gap-2 mt-6 text-[#94A3B8]">
            <MapPin size={16} className="text-[#FACC15]" />
            <span className="text-sm">{SITE.area}</span>
          </div>
          <div className="flex items-center gap-3 mt-6">
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
               aria-label="Instagram"
               className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[#F8FAFC] hover:bg-[#FACC15] hover:text-[#020617] hover:border-[#FACC15] transition-colors duration-300">
              <Instagram size={18} />
            </a>
            <a href={SITE.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook"
               aria-label="Facebook"
               className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-[#F8FAFC] hover:bg-[#FACC15] hover:text-[#020617] hover:border-[#FACC15] transition-colors duration-300">
              <Facebook size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-label text-[10px] text-[#94A3B8] mb-5">Contact</p>
          <ul className="space-y-4">
            <li><a href={`tel:${SITE.phoneRaw}`} className="flex items-center gap-3 text-[#F8FAFC] hover:text-[#FACC15] transition-colors duration-300" data-testid="footer-phone"><Phone size={16} /> {SITE.phoneDisplay}</a></li>
            <li><a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[#F8FAFC] hover:text-[#FACC15] transition-colors duration-300" data-testid="footer-whatsapp"><MessageCircle size={16} /> WhatsApp</a></li>
            <li><a href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-[#F8FAFC] hover:text-[#FACC15] transition-colors duration-300" data-testid="footer-email"><Mail size={16} /> {SITE.email}</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono-label text-[10px] text-[#94A3B8] mb-5">Explore</p>
          <ul className="space-y-3">
            {["services", "inclusive", "online", "areas", "faq", "contact"].map((id) => (
              <li key={id}>
                <button onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                        className="text-[#94A3B8] hover:text-[#F8FAFC] capitalize transition-colors duration-300 text-sm" data-testid={`footer-link-${id}`}>
                  {id}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-[#94A3B8] text-xs">
        <span>© {new Date().getFullYear()} {SITE.brand} — {SITE.tagline}. All rights reserved.</span>
        <span>{SITE.domain}</span>
      </div>
    </div>
  </footer>
);
